import React from 'react';
import './AddSkillBtn.css';
import { FaPlus } from "react-icons/fa6";


export const AddSkillBtn = (props) => {
  return (
    <div
      className="div-block-475 add_skill"
      prop-events-names="onClick"
      prop-events-value-onclick="handleAddSkillBtnClick"
    >
      <FaPlus className={"image-152 add_sk"} color={"#FFFFFF"} style={{
        width:"14px",
        height:"14px",
      }} />
      {/*<img
        alt=""
        className="image-152 add_sk"
        loading="lazy"
        src="images/plus_1plus.png"
      />*/}
      <div className="text-block-284 add_skill_text">Add Skill</div>
    </div>
  );
};
